import {
  Button,
  Divider,
  Heading,
  Image,
  Text,
  View,
  useAuthenticator,
} from "@aws-amplify/ui-react";
import type { AuthenticatorProps } from "@aws-amplify/ui-react";

import evidoLogoUrl from "@assets/logos/main_logo_green.png";

/**
 * Labels and placeholders of the sign-in inputs.
 *
 * Amplify's defaults capitalise the noun ("Enter your Username"); the brand
 * guide does not. The username field also takes an email, a sign-in alias.
 */
export const LOGIN_FORM_FIELDS: NonNullable<AuthenticatorProps["formFields"]> =
  {
    signIn: {
      username: {
        label: "Username or email",
        placeholder: "Enter your username or email",
      },
      password: { placeholder: "Enter your password" },
    },
  };

/**
 * Title block above the sign-in form.
 *
 * Amplify renders this slot outside the form element, so it carries its own
 * padding rather than inheriting `authenticator.form.padding`.
 */
export function LoginHeader() {
  return (
    <View padding="3.5rem 2.5rem 1.5rem" textAlign="center">
      <Heading level={3} margin="0">
        Welcome to LiverPRO Cloud
      </Heading>
      <Text color="font.secondary" fontSize="14px" marginTop="0.5rem">
        Sign in to your account
      </Text>
    </View>
  );
}

/**
 * Replaces Amplify's default sign-in footer, which is the "Forgot your
 * password?" button on its own, with the divider, link and brand mark from the
 * approved design.
 */
export function LoginFooter() {
  const { toForgotPassword } = useAuthenticator((context) => [
    context.toForgotPassword,
  ]);

  return (
    <View data-amplify-footer="" marginTop="1rem">
      <Divider label="or" />
      <Button
        onClick={toForgotPassword}
        variation="link"
        size="small"
        fontSize="14px"
        marginTop="0.5rem"
        width="100%"
      >
        Forgot your password?
      </Button>
      <Image
        alt="evido.health"
        src={evidoLogoUrl}
        display="block"
        width="180px"
        margin="2.5rem auto 0"
      />
    </View>
  );
}
